module.exports = __webpack_public_path__ + "media/video706.148b367f.mp4";